import React, { useContext, createContext, useState } from 'react'
import { RiskCategory } from '../risks.constants'

export type RisksContextType = {
  sortColumn: string
  setSortColumn: React.Dispatch<React.SetStateAction<string>>
  sortType: 'asc' | 'desc'
  setSortType: React.Dispatch<React.SetStateAction<'asc' | 'desc'>>
  categoryOptions: RiskCategory[]
  setCategoryOptions: React.Dispatch<React.SetStateAction<RiskCategory[]>>
  controlSortColumn: string
  setControlSortColumn: React.Dispatch<React.SetStateAction<string>>
  controlSortType: 'asc' | 'desc'
  setControlSortType: React.Dispatch<React.SetStateAction<'asc' | 'desc'>>
}

export const RisksContext = createContext<RisksContextType>({
  sortColumn: '',
  setSortColumn: () => null,
  sortType: 'asc',
  setSortType: () => null,
  categoryOptions: [],
  setCategoryOptions: () => null,
  controlSortColumn: '',
  setControlSortColumn: () => null,
  controlSortType: 'asc',
  setControlSortType: () => null,
})

export const RisksProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [sortColumn, setSortColumn] = useState<string>('')
  const [controlSortColumn, setControlSortColumn] = useState<string>('')
  const [sortType, setSortType] = useState<'asc' | 'desc'>('asc')
  const [controlSortType, setControlSortType] = useState<'asc' | 'desc'>('asc')
  const [categoryOptions, setCategoryOptions] = useState<RiskCategory[]>([])

  return (
    <RisksContext.Provider
      value={
        {
          sortColumn,
          setSortColumn,
          sortType,
          setSortType,
          categoryOptions,
          setCategoryOptions,
          controlSortColumn,
          setControlSortColumn,
          controlSortType,
          setControlSortType,
        } as RisksContextType
      }
    >
      {children}
    </RisksContext.Provider>
  )
}

export const useRisksContext = (): RisksContextType => {
  return useContext(RisksContext)
}
